import React from 'react';
import ReactDOM from 'react-dom';
import '@fontsource/roboto';
import './index.css';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { LocalizationProvider } from '@mui/lab';
import { BrowserRouter } from 'react-router-dom';
import { getAppConfig } from 'startup/get-app-config';
import { registerGoogleAnalytics } from 'startup/register-google-analytics';
import App from './App';
import {
  DocumentService,
  LookupService,
  FileAccessService,
  EventService,
  ExportService,
  getBrowserAuthClients,
  AuthorizationService,
  DataAccessService,
} from '@price-for-profit/micro-services';
import {
  ProvideQueryClient,
  ProvideAuth,
  ProvideTheme,
  ProvideService,
  ProvideSnackbar,
  ProvideErrorBoundary,
} from 'shared/providers';
import {
  NotificationService,
  CustomerService,
  ProductService,
  ContractService,
  DraftContractService,
  DraftCustomerNameChangeService,
  QuoteService,
} from 'shared/services';

//import reportWebVitals from './reportWebVitals';
const run = async () => {
  const baseUrl = process.env.PUBLIC_URL;
  const appConfig = await getAppConfig(baseUrl);
  const { clientApp, httpClient } = getBrowserAuthClients({
    clientId: appConfig.appId,
    authDomainHost: appConfig.authDomainHost,
    authorityUrl: appConfig.authorityUrl,
    cacheLocation: 'sessionStorage',
    serviceBaseUrl: appConfig.serviceBaseUrl,
    clientScopes: {
      das: appConfig.dasAppId,
      docs: appConfig.documentAppId,
      lookup: appConfig.lookupAppId,
      export: appConfig.exportAppId,
      fas: appConfig.fileAccessAppId,
      event: appConfig.eventAppId,
      auth: appConfig.authorizationAppId,
    },
  });

  const exportService = new ExportService(httpClient);
  const eventService = new EventService(httpClient);
  const documentService = new DocumentService(httpClient);
  const dataAccessService = new DataAccessService(httpClient);
  const fileAccessService = new FileAccessService(httpClient);
  const lookupService = new LookupService(httpClient);
  const authService = new AuthorizationService(httpClient);

  const notificationService = new NotificationService(eventService);
  const customerService = new CustomerService(lookupService, documentService, notificationService);
  const productService = new ProductService(lookupService);
  const quoteService = new QuoteService(
    dataAccessService,
    documentService,
    fileAccessService,
    exportService,
    lookupService,
    eventService,
    authService
  );
  const contractService = new ContractService(documentService, fileAccessService, notificationService);
  const draftContractService = new DraftContractService(documentService);
  const draftNameChangeService = new DraftCustomerNameChangeService(documentService);

  const serviceContext = {
    appConfig,
    customerService,
    productService,
    quoteService,
    contractService,
    draftContractService,
    draftNameChangeService,
    eventService,
    authService,
  };

  if (appConfig.enableGoogleAnalytics) {
    registerGoogleAnalytics(appConfig.googleTagId);
  }

  ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter basename={baseUrl}>
        <ProvideTheme>
          <ProvideSnackbar>
            <ProvideErrorBoundary>
              <ProvideService context={serviceContext}>
                <ProvideAuth clientApp={clientApp}>
                  <ProvideQueryClient>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <App />
                    </LocalizationProvider>
                  </ProvideQueryClient>
                </ProvideAuth>
              </ProvideService>
            </ProvideErrorBoundary>
          </ProvideSnackbar>
        </ProvideTheme>
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
  );
};

run().catch(console.error);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
